export default __webpack_public_path__ + "static/media/XK.4e83593f.svg";